import React from "react";
import { BiError } from "react-icons/bi";


const DeleteModal = ({  isOpen, onClose, onDelete }) => {
  
  const handleDelete = () => {
    // dispatch(deleteFieldFormAction(id));
    onDelete();
    onClose();
  };
  return (
    <>
      <div
        className={
          isOpen
            ? "w-full h-screen duration-500 absolute top-0 left-0"
            : "w-full h-screen duration-500 absolute top-0 opacity-0 -z-50 left-0"
        }
      >
        <div
          className={`bg-slate-900/20 absolute backdrop-blur-md w-full h-screen ${
            isOpen ? "z-50" : "-z-50"
          } duration-500 `}
        >
          <div className="bg-white p-4 rounded-md shadow-md w-11/12 m-auto lg:w-3/12 mt-20">
            <div className="w-full  flex justify-center">
              <p className="text-red-600 text-4xl rounded-full p-2   bg-red-500 bg-opacity-20 flex justify-center  ">
                <BiError />
              </p>
            </div>
            <div>
              <p className="text-center font-bold mt-2 text-2xl">
                Are You Sure ?{" "}
              </p>
              <p className="text-gray-700 font-semibold text-center">
                This action can not be undone . All values
              </p>
              <p className="text-gray-700 font-semibold text-center">
                associated with this field will be lost.
              </p>
            </div>

            <button
              onClick={handleDelete}
              className="btn-red w-full text-center justify-center font-bold mt-2"
            >
              {" "}
              Delete Field
            </button>
            <button
              onClick={onClose}
              o
              className="border-gray-400 py-0.5 rounded-sm shadow-md border bg-gray-100 hover:bg-slate-200 duration-500 bg-transparent w-full text-center justify-center font-bold mt-2"
            >
              {" "}
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteModal;
